import { Brands } from '@core-ui/react-stitch';
import brandConfig from './allowed-quick-facets-config';

const removeFs = (brand: string) => brand.replace('fs', '');

const isOldNavy = (brand: string) => brand === Brands.OldNavy;

const getPillFilterFacets = (brand: string) =>
  isOldNavy(brand) ? ['rise'] : ['style'];

export const prepareAllowedFacetsAsPerBrand = (
  brand: string,
  ABsegValue: string
): string[] => {
  if (ABsegValue === 'b') {
    return getPillFilterFacets(brand);
  }
  return brand ? brandConfig[removeFs(brand)].allowedFacets : [];
};
